<template>
	<v-container>
		<v-card-actions>
			<v-spacer />
			<action-menu
				entity="job"
				:title="$tc('entities.job.title', 1)"
				:data="value"
			/>
		</v-card-actions>
		<v-tabs v-model="tab" vertical>
			<v-tab key="general">{{ $t("general") }}</v-tab>
			<v-tab key="CustomFields">{{ $tc("customFields") }}</v-tab>
			<v-tab key="jobstages">{{ $tc("entities.jobStage.title", 2) }}</v-tab>

			<v-tabs-items v-model="tab">
				<v-tab-item key="general">
					<v-form v-model="valid" ref="form">
						<v-text-field
							:label="$t('entities.job.props.code')"
							:rules="$isRequiredRule"
							v-model="value.code"
						></v-text-field>
						<v-checkbox
							:label="$t('entities.job.props.group')"
							v-model="value.group"
						></v-checkbox>
						<v-text-field
							:label="$t('entities.job.props.description')"
							:rules="$isRequiredRule"
							v-model="value.description"
						></v-text-field>
						<auto-complete-entity
							ref="item"
							v-model="value.itemId"
							entityApi="item"
							:itemPreSelected="selectedItem"
							itemText="description"
							itemValue="id"
							@change="itemChange"
							:label="$t('entities.job.props.item')"
							prependIcon="mdi-find-replace"
						/>
						<v-select
							v-model="value.environmentId"
							:items="environments"
							item-text="description"
							item-value="id"
							:label="$t('entities.job.props.environmentId')"
							:rules="$isRequiredRule"
						></v-select>
						<v-select
							v-model="value.versionId"
							:items="versions"
							item-text="description"
							item-value="id"
							:label="$t('entities.job.props.version')"
							:clearable="true"
						></v-select>
						<v-text-field
							:label="$t('entities.job.props.qt')"
							v-model="value.qt"
							type="number"
						></v-text-field>
						<auto-complete-entity
							ref="account"
							v-model="value.accountId"
							entityApi="account"
							:itemPreSelected="selectedAccount"
							fieldApi="name"
							itemText="name"
							itemValue="id"
							:label="$t('entities.job.props.accountId')"
							prependIcon="mdi-find-replace"
						/>
						<date-dialog
							v-model="value.deadline"
							:label="$t('entities.job.props.deadline')"
							@changeDate="value.deadline = $event"
							format="DD/MM/YYYY"
						></date-dialog>
						<v-text-field
							:label="$t('entities.job.props.notes')"
							v-model="value.notes"
						></v-text-field>
					</v-form>
				</v-tab-item>
				<v-tab-item key="CustomFields" eager>
					<entity-field-custom-autoform
						v-model="value"
						entity="Job"
					></entity-field-custom-autoform>
				</v-tab-item>
				<v-tab-item key="jobstages">
					<v-alert v-if="!value.environmentId" type="error">{{
						`${$tc("entities.job.title", 1)} ${$t(
							"entities.job.props.environmentId"
						)} : ${$t("errors.fieldRequired")}`
					}}</v-alert>

					<jobStageFormOffline
						ref="jobStagesFormRef"
						v-else
						v-model="value.jobStages"
						:environmentId="value.environmentId"
					/>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</v-container>
</template>

<script>
	import itemService from "@/services/itemService.js";
	import accountService from "@/services/accountService.js";
	import environmentService from "@/services/environmentService.js";
	import versionService from "@/services/versionService.js";
	import jobStageFormOffline from "@/components/forms/jobStages/jobStageFormOffline";
	export default {
		props: {
			value: {
				default() {
					return {
						code: "",
						versionId: "",
						environmentId: "",
						accountId: "",
						jobStages: [],
					};
				},
			},
		},
		components: {
			jobStageFormOffline,
		},
		data() {
			return {
				tab: null,
				valid: true,
				selectedItem: {},
				selectedAccount: {},
				environments: [],
				versions: [],
				alert: {
					alerts: [],
					type: "error",
				},
			};
		},
		watch: {
			async value() {
				this.$refs.form.resetValidation();
				this.selectedItem = "";
				this.selectedAccount = "";
				await this.getItems();
			},
			async selectedItem() {
				if (
					!this.value.description ||
					(this.value.description == "" && this.selectedItem)
				) {
					this.value.description = this.selectedItem.description;
				}
				await this.getVersions();
			},
		},
		methods: {
			itemChange(item) {
				this.value.environmentId = item.environmentId;
			},
			isValid() {
				if (this.$refs.jobStagesFormRef != null) {
					let jobStagesIsValid = this.$refs.jobStagesFormRef.saveChanges();
					if (!jobStagesIsValid) return false;
				}
				return this.$refs.form.validate();
			},

			async selectItem(row) {
				this.value.itemId = row.id;
				this.selectedItem = row;
				await this.getVersions();
			},
			selectAccount(row) {
				this.selectedAccount = row;
				this.value.accountId = row.id;
			},
			async getItemById() {
				if (!this.value.itemId) return;
				let res = await itemService.getById(this.value.itemId);

				if (res.success) this.selectedItem = res.data;
				else this.alert.alerts = res.data;
			},
			async getAccountById() {
				if (!this.value.accountId) return;
				let res = await accountService.getById(this.value.accountId);
				if (res.success) this.selectedAccount = res.data;
				else this.alert.alerts = res.data;
			},
			async getEnvironments() {
				let res = await environmentService.getAll();
				if (res.success) this.environments = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getVersions() {
				if (!this.value.itemId) return;
				let res = await versionService.getAll(this.value.itemId);
				if (res.success) this.versions = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getItems() {
				await this.getEnvironments();
				await this.getAccountById();
				await this.getItemById();
				await this.getVersions();
			},
		},
		async mounted() {
			await this.getItems();
		},
	};
</script>
